import { Text } from "basis";
import { useLayout } from "library/hooks/useLayout";
import { SvgInline } from "../../SvgInline/SvgInline";
import styles from "./pagination.module.scss";
import { Link } from "./types";

interface Props {
  page?: number;
  previousPageClicked: () => void;
  nextPageLink?: Link;
  nextPageClicked: () => void;
}

export const Pagination = ({
  page = 1,
  previousPageClicked,
  nextPageLink,
  nextPageClicked,
}: Props) => {
  const { scrollToTop } = useLayout();

  return (
    <div id="transaction-actions" className={styles.actionsBg}>
      <div className={styles.paging}>
        <button
          className={`${styles.triangle} ${page === 1 ? styles.inactive : ""}`}
          aria-label="Previous page"
          disabled={page === 1}
          onClick={previousPageClicked}
          type="button"
          data-testid="prevPageButton"
        />
        <Text margin="0 3" testId="pageNumber">{`Page ${page}`}</Text>
        <button
          className={`${styles.triangle} ${
            !nextPageLink ? styles.inactive : ""
          }`}
          aria-label="Next page"
          disabled={!nextPageLink}
          onClick={nextPageClicked}
          type="button"
          data-testid="nextPageButton"
        />
      </div>
      <div className={styles.actions}>
        <div className={styles.backToTop}>
          <button
            className={styles.backToTopButton}
            type="button"
            onClick={scrollToTop}
          >
            <div className={styles.backToTopText}>Back to top</div>
            <div className={styles.backToTopChevronContainer}>
              <SvgInline
                className={styles.backToTopChevron}
                name="chevron-blue"
              />
            </div>
          </button>
        </div>
      </div>
    </div>
  );
};
